import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { useKeysStore } from '../../../../core/store/useKeysStore';
import { getUserSession } from '../../../../core/util/core/Session';
import config from '../../../config/config';

function List() {
    const session = getUserSession();
    const { keys } = useKeysStore();

    const { application_profile_id } = session.user;

    const isAdminOrBusinessManager =
        application_profile_id ==
            keys?.default_foreign_key?.pdc_profiles?.business_manager ||
        application_profile_id == keys?.default_foreign_key?.pdc_profiles?.admin;

    const pathFrontEnd = '/suppliers/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}people/delete`,
        endpoint: config.endpoints.backend + 'people/getSuppliers'
    };

    let list = {
        labelTitle: 'Lista de Fornecedores',
        labelTitleButtonAdd: 'Incluir novo fornecedor',
        fieldsShowOnDelete: ['name'],
        showPrintButtons: true,
        canDelete: isAdminOrBusinessManager,
        canEdit: isAdminOrBusinessManager,
        filter: {
            pdc_company_id: session.loggedUserInfo.pdc_company_id
        },
        columns: [
            {
                name: 'people_name',
                label: 'Nome do fornecedor',
                width: '20%'
            },
            {
                name: 'document',
                label: 'Documento',
                width: '15%'
            },
            {
                name: 'address',
                label: 'Endereço'
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
